import { ApiHandlerDiscreteParameter, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { UpdateCartLineApiParameter } from "@insite/client-framework/Services/CartService";

interface SetRedirectedFromCheckoutParameter {
    isRedirectedFromCheckout?: boolean;
}

type HandlerType = ApiHandlerDiscreteParameter<SetRedirectedFromCheckoutParameter, UpdateCartLineApiParameter>;

export const DispatchCompleteSetRedirectCheckout: HandlerType = props => {
    props.dispatch({
        type: "Custom/CheckoutShipping/RedirectToCartPage",
        redirectToCartPage: props.parameter.isRedirectedFromCheckout,
    } as any);
};

export const chain = [DispatchCompleteSetRedirectCheckout];

const setRedirectedFromCheckout = createHandlerChainRunner(chain, "SetRedirectedFromCheckout");
export default setRedirectedFromCheckout;
